// =============================================================================
// Mega Nav
// =============================================================================

$('document').ready(() => {
    const $openButton = $('[href="#site-menu"]');
    const $closeButton = $('[href="#close"]');
    const $megaNav = $('.mega-nav');
    const $body = $('body');

    const handleClickOpen = event => {
        event.preventDefault();
        $megaNav.addClass('mega-nav--open');
        $body.addClass('mega-nav-opened');
    };

    const handleClickClose = event => {
        event.preventDefault();
        $megaNav.removeClass('mega-nav--open');
        $body.removeClass('mega-nav-opened');
    };

    $openButton.on('click', handleClickOpen.bind(this));
    $closeButton.on('click', handleClickClose.bind(this));

    $(document).keyup(event => {
        if (event.keyCode === 27) {
            handleClickClose(event);
        }
    });
});



// WEBPACK FOOTER //
// ./public/themes/masuri/assets/js/library/MegaNav.js